import React, { useEffect, useMemo } from 'react';

import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { OverlayComponent } from 'app/components';

import { hasChanges } from '../utils/has-changes';
import { activeItemSelected } from '../utils/selected-value';
import { linkCodesTranslation } from '../constants';
import { useDetailsSelectors, useListActionsSelectors, useListBranchSelectors } from '../hooks';
import { LinkCodesDetails } from './link-codes-details';
import { LinkCodesErrors } from './link-codes-errors';
import { LinkCodesHeader } from './link-codes-header';
import { LinkCodesPrompt } from './link-codes-prompt';
import { LinkCodesResults } from './link-codes-results';

import styles from './link-codes-list.scss';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { withRouter } from 'app/components/enhancers/with-router';

interface LinkCodesListProps {
  breadcrumbs: number[];
  route: any;
  linkSubset: boolean;
}

export const LinkCodesList: React.FC<LinkCodesListProps> = ({
  breadcrumbs, route, linkSubset
}) => {

  const { listBranch } = useListBranchSelectors();
  const { listActions, updating, activeValueError } = useListActionsSelectors();
  const { activeValue, activeType } = useDetailsSelectors();
  const LinkCodesPromptWithRouter = withRouter(LinkCodesPrompt);

  const shouldPrompt = useMemo(
    () => hasChanges(listBranch, listActions, activeItemSelected(activeValue, activeType)),
    [listBranch, listActions, activeValue?.value, activeType]
  );

  const translation = useTranslation(STATE.linkCodes, linkCodesTranslation);

  useEffect(() => scrollToTop(), []);

  return <>
    <LinkCodesPromptWithRouter
      route={route}
      shouldPrompt={shouldPrompt}
      translation={translation} />
    <LinkCodesErrors
      translation={translation} />
    <OverlayComponent
      displayOverlay={updating}
      overlayText={translation.message_updating} />
    <div className={styles.header}>
      <MainGridContainer>
        <LinkCodesHeader
          linkSubset={linkSubset}
          breadcrumbs={breadcrumbs}
          translation={translation} />
        <LinkCodesDetails
          shouldPrompt={shouldPrompt}
          activeValueError={activeValueError}
          translation={translation} />
      </MainGridContainer>
    </div>
    <div className={styles.body}>
      <MainGridContainer>
        <LinkCodesResults
          hasChanges={shouldPrompt}
          translation={translation} />
      </MainGridContainer>
    </div>
  </>;
};
